import './NavBar.scss';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import logoProsa from '../../assets/images/logo-prosa.png';
import { Button } from 'react-bootstrap';
import { GoogleOAuthProvider,useGoogleLogin } from '@react-oauth/google';
import { setToken, setRoli, setUsuarioi, getApiCliGoo } from '../../Utilidades/session';
import { useSelector, useDispatch } from 'react-redux';
import { login, logout } from '../../stores/AuthUser';
import { refreshTokenSetup } from '../../Utilidades/refreshToken';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { StatusAlertService } from 'react-status-alert';
import { getPermisosUsuario } from '../../Services/UsuariosService';
import { authInitialized } from '../../stores/App';

export const NavBar = () => {
  var a = getApiCliGoo();
  var clientId: string = String(getApiCliGoo() || '');
  const dispatch = useDispatch();
  const iniciado = useSelector((state: any) => state.authUser.loggedIn);
  const navigate = useNavigate();
  const location = useLocation();
  const redi = useSelector((state: any) => state.authUser.redi);

  const onSuccess = (res: any) => {
    // console.log('success:', res.profileObj);
    //console.log('success:', res);
    setToken(res.tokenObj.access_token);
    refreshTokenSetup(res);
    //dispatch(token(res.tokenObj));
    getPermisosUsuario(res.profileObj.googleId)
      .then((response) => {
        if (
          response.data?.data.length &&
          response.data?.data[0].tiporol_id?.pantallas?.length
        ) {
          setRoli(response.data.data[0].tiporol_id.tiporol_id);
          setUsuarioi(response.data.data[0].usuario_id);

          const data = {
            ...res.profileObj,
            usuarioId: response.data.data[0].usuario_id,
            pantallas: response.data.data[0].tiporol_id.pantallas.filter(
              (p) => p.selected
            ),
          };

          dispatch(login(data));
          dispatch(authInitialized());

          //Modificacion: Marca de Inicio WII C-24-1229-24
          if (redi != null && redi != '') {
            navigate(redi || "/", { replace: false });
          }

        }
        else if (
          response.data?.data.length &&
          response.data?.data[0].invitado == 1
        ) {
          setRoli("");
          setUsuarioi("");

          const data = {
            ...res.profileObj,
            usuarioId: 0,
            pantallas: [],
          };

          dispatch(login(data));
          dispatch(authInitialized());

          if (redi != null && redi != '') {
            navigate(redi || "/", { replace: false });
          }
          //Modificacion: Marca de Fin WII C-24-1229-24

        }
        else {
          const err = response as any;
          const msg =
            err.response.data?.meta.message ||
            err.response.data?.meta.status ||
            err.message;

          StatusAlertService.showError(msg);
          setToken('');
          dispatch(logout());
        }
      })
      .catch((err) => {
        setToken('');
        dispatch(logout());
        dispatch(authInitialized());
      });
  };
  const onFailure = (err: any) => {
    setToken('');
    dispatch(logout());
    dispatch(authInitialized());
  };
  const logOut = () => {
    setToken('');
    dispatch(logout());
    navigate('/', { replace: true });
  };
  const onAutoLoad = (iniciado: boolean) => {
    const currentPath = location.pathname ? location.pathname : '/';
    const parts = currentPath.split('/');
    const path = parts[1].toLowerCase();
    if (!iniciado && path == "vista-comunicado") {
      setToken('');
      dispatch(logout());
      navigate('/', { replace: true });
    }
  };

  const WebLogin = () => {
    const login = useGoogleLogin({
      onSuccess: (tokenResponse) => {
        //console.log('Login Success:', tokenResponse)
        onSuccess(tokenResponse);
      },
      onError: (error) => {
        logOut();
      },
      // flow: 'auth-code', // Optional: Use for server-side auth
    });
  
    return (
      <Button
          onClick={() => login()}
          className="buton-none"
          variant="primary"
      >
      <div className="material-icons">account_circle</div>
        Iniciar Sesión
      </Button>
    );
};

  return (
    <>
      <Navbar expand="lg" sticky="top" className="shadow mb-0">
        <Container fluid className="px-5">
          <Link to={'/'}>
            <img className="logo-prosa" src={logoProsa} />
          </Link>
          {iniciado ? (
            <Button
            onClick={logOut}
            variant="primary-light"
            >
            <div className="material-icons">account_circle</div>
              Cerrar sesión
            </Button>
          ) : (
            <GoogleOAuthProvider clientId={clientId} >
              <WebLogin />
            </GoogleOAuthProvider>
          )}
        </Container>
      </Navbar>
    </>
  );
};
